// Homework: student exercise components + teacher homework modal + editor
const dict = {
  uk: {
    // Teacher modal for reviewing student homework submissions
    teacherModal: {
      title: 'Домашні завдання учнів',
      empty: 'Немає домашніх завдань',
      emptyHint: 'Поки що жоден учень не надіслав домашнє завдання',
      statusSubmitted: 'На перевірці',
      statusGraded: 'Перевірено',
      statusInProgress: 'В процесі',
      sectionNotSent: 'Не надіслано ({{count}})',
      sectionAwaitingReview: 'Очікують перевірки ({{count}})',
      sectionGraded: 'Перевірені ({{count}})',
      gradeTitle: 'Оцінити роботу: {{name}}',
      scoreLabel: 'Оцінка (макс: {{max}})',
      scorePlaceholder: 'Автоматична оцінка',
      commentLabel: 'Коментар для учня',
      commentPlaceholder: 'Напишіть коментар про виконану роботу...',
      saveGrade: 'Зберегти оцінку',
      cancel: 'Скасувати',
      submittedAt: 'Надіслано: {{date}}',
      view: 'Переглянути',
      viewWorkTitle: 'Переглянути роботу',
      lessonAt: 'Урок: {{date}}',
      sending: 'Надсилання…',
      send: 'Надіслати',
    },
    // AudioRecorder used in shadowing exercises
    recorder: {
      errorNotAllowed: 'Дозвольте доступ до мікрофона для запису голосу',
      errorNotFound: 'Мікрофон не знайдено. Підключіть мікрофон та спробуйте знову',
      errorGeneric: 'Помилка запису. Перевірте мікрофон та спробуйте знову',
      paused: 'Пауза',
      recording: 'Запис...',
      pressToRecord: 'Натисніть для запису',
      pauseButton: 'Пауза',
      resumeButton: 'Продовжити',
      maxSeconds: 'Максимум {{count}} секунд',
      yourRecording: 'Ваш запис ({{time}})',
      recordAgain: 'Записати знову',
      submitForReview: 'Надіслати на перевірку',
    },
    // Dictation student exercise
    dictation: {
      defaultQuestion: 'Прослухайте і запишіть текст',
      audioSectionLabel: 'Аудіо для диктанту',
      audioHint: 'Можна прослухати скільки завгодно разів.',
      audioMissing: 'Аудіо для цього диктанту ще не завантажено.',
      answerLabel: 'Ваша відповідь',
      answerPlaceholder: 'Запишіть тут те, що чуєте...',
      answerHint: 'Пунктуація і регістр не враховуються. Дається одна спроба.',
      submit: 'Здати диктант',
    },
    // Dictation and shadowing result panels
    results: {
      perfect: 'Бездоганно!',
      great: 'Чудова робота!',
      okButErrors: 'Непогано, але є помилки',
      okButCanImprove: 'Непогано, але можна краще',
      needsMoreWork: 'Потрібно ще попрацювати',
      needsPractice: 'Потрібно попрактикуватись',
      passingScore: 'Прохідний бал: {{score}}%',
      correct: 'Правильно',
      withErrors: 'З помилками',
      missed: 'Пропущено',
      extra: 'Зайвих',
      wordByWord: 'Розбір по словах',
      wordAnalysis: 'Аналіз слів',
      wordAnalysisHint: '(натисніть на слово для деталей)',
      intonationAnalysis: 'Аналіз інтонації',
      legendCorrect: 'Правильно',
      legendPartial: 'З описками',
      legendError: 'Помилка / пропущено',
      legendExtra: 'Зайве слово',
      yourAnswer: 'Ваша відповідь:',
      empty: '(порожньо)',
      referenceText: 'Правильний текст:',
      referenceTextEtalon: 'Еталонний текст:',
      missedWord: 'Пропущено: {{word}}',
      extraWord: 'Зайве слово',
      expected: 'Очікувалось: {{word}}',
      textLabel: 'Текст',
      textDescription: 'Правильність слів',
      tempoLabel: 'Темп',
      tempoDescription: 'Швидкість мовлення',
      intonationLabel: 'Інтонація',
      intonationDescription: 'Мелодика мови',
      weight: 'Вага: {{value}}',
      expectedShort: 'Очікувалось:',
      spoken: 'Сказано: ',
      word: 'Слово: ',
      score: 'Оцінка: ',
      pronunciationHint: 'Вимова потребує покращення',
      sentence: 'Речення {{n}}',
      receivedShort: 'Отримано:',
      rising: 'Підйом',
      falling: 'Спад',
    },
    // Shadowing exercise
    shadowing: {
      stepWatch: '1. Дивитись',
      stepRecord: '2. Записати',
      stepResult: '3. Результат',
      attempt: 'Спроба {{current}}/{{max}}',
      analysisError: 'Помилка аналізу. Спробуйте записати знову.',
      defaultQuestion: 'Прослухайте та повторіть',
      listenCarefully: 'Уважно слухайте вимову та інтонацію',
      recordYourAnswer: 'Записати свою відповідь',
      listenFirst: 'Спочатку прослухайте',
      canRecordEarly: 'Ви можете записати, не чекаючи кінця відео',
      recordHeading: 'Запишіть свою відповідь',
      recordHint: 'Повторіть текст чітко та з правильною інтонацією',
      textToRepeat: 'Текст для повторення:',
      listenAgain: 'Прослухати ще раз',
      analyzing: 'Аналізуємо вашу вимову...',
      analysisFirstLoad: 'Перше завантаження може зайняти більше часу',
      progressRecognizing: 'Розпізнаємо мову...',
      progressLoadingModel: 'Завантаження моделі: {{progress}}%',
      progressIntonation: 'Аналізуємо інтонацію...',
      progressComparing: 'Порівнюємо з еталоном...',
      notRecognized: '(не розпізнано)',
      improveResult: 'Покращити результат ({{n}} {{label}} залишилось)',
      tryAgain: 'Спробувати ще раз ({{n}} залишилось)',
      attemptsUsed: 'Ви використали всі спроби',
      studentRecording: 'Запис учня:',
      attemptSingular: 'спроба',
      attemptPlural: 'спроби',
    },
    // Coloring exercise
    coloring: {
      imageMissing: 'Зображення для цієї вправи не завантажене.',
      palette: 'Палітра',
      colorLabel: 'Колір {{color}}',
      erase: 'Стерти',
      reset: 'Скинути',
    },
    // HomeworkEditor labels (partial - toolbar-level)
    editor: {
      title: 'Редактор домашнього завдання',
      moduleTestTitle: 'Редактор модульного тесту',
      backToDashboard: 'Назад',
      saveButton: 'Зберегти',
      saving: 'Збереження...',
      addExercise: 'Додати вправу',
      titleLabel: 'Назва',
      descriptionLabel: 'Опис',
      programLabel: 'Програма',
      lessonLabel: 'Урок',
      moduleLabel: 'Модуль',
      passingScoreLabel: 'Прохідний бал',
      timeLimitLabel: 'Ліміт часу (хв)',
      autoAssignLabel: 'Автоматично призначати після уроку',
      notesLabel: 'Нотатки',
      mediaLabel: 'Матеріали',
      vocabularyLabel: 'Словник',
      totalPoints: 'Всього балів: {{points}}',
      errorTitle: 'Помилка',
      common: {
        cancel: 'Скасувати',
        save: 'Зберегти',
        add: 'Додати',
        delete: 'Видалити',
        edit: 'Редагувати',
        done: 'Готово',
        duplicate: 'Дублювати',
        instruction: 'Інструкція',
        pointsLabel: 'Бали',
        image: 'Зображення',
        audio: 'Аудіо',
        video: 'Відео',
        text: 'Текст',
        upload: 'Завантажити',
        uploading: 'Завантаження…',
        moveUp: 'Перемістити вгору',
        moveDown: 'Перемістити вниз',
      },
      alerts: {
        enterTestTitle: 'Будь ласка, введіть назву тесту',
        enterHomeworkTitle: 'Будь ласка, введіть назву завдання',
        addAtLeastOneTestExercise: 'Додайте хоча б одне завдання до тесту',
        addAtLeastOneItem: 'Додайте хоча б одну вправу, конспект або слова до словника',
        saveFailed: 'Не вдалося зберегти',
        fileTooLarge5: 'Файл занадто великий. Максимальний розмір: 5MB',
        fileTooLarge50: 'Файл занадто великий. Максимальний розмір: 50MB',
        fileTooLarge100: 'Файл занадто великий. Максимальний розмір: 100MB',
        fileTooLargeAudio50Image5: 'Файл занадто великий. Максимальний розмір: {{limit}}',
        uploadFailed: 'Не вдалося завантажити файл: {{message}}',
        uploadAudioFirst: 'Спочатку завантажте відео або аудіо',
        uploadAudioFormats: 'Будь ласка, завантажте аудіофайл (MP3, WAV, OGG, M4A)',
        uploadVideoFormats: 'Будь ласка, завантажте відеофайл (MP4, WebM, MOV)',
        uploadAudioPlain: 'Будь ласка, завантажте аудіофайл',
        uploadImagePlain: 'Будь ласка, завантажте зображення',
        imageOnly: 'Підтримуються лише зображення',
        crosswordGenError: 'Помилка при генерації кросворда',
        crosswordGenNone: 'Не вдалось згенерувати сітку. Спробуйте збільшити розмір сітки.',
        crosswordGenPartial: 'Вдалось розмістити {{placed}} з {{total}} слів. Спробуйте збільшити розмір сітки або скоротити слова.',
        addWordMin2: 'Додайте хоча б одне слово (мінімум 2 літери)',
        invalidJsonFormat: 'Невірний формат. Використовуйте масив об\'єктів з полями word, start, end.',
        parseJsonError: 'Помилка парсингу JSON. Перевірте формат.',
        dragImageFile: 'Будь ласка, перетягніть файл зображення',
        dragAudioFile: 'Будь ласка, перетягніть аудіофайл',
        svgFormat: 'Будь ласка, оберіть файл у форматі SVG',
        svgNoPaths: 'У SVG не знайдено областей для розмальовки (path, rect, circle тощо)',
        svgProcessFailed: 'Не вдалося обробити SVG-файл',
      },
      confirms: {
        deleteExerciseTitle: 'Видалити вправу?',
        deleteExerciseMessage: 'Видалити цю вправу?',
      },
      loading: {
        test: 'Завантаження тесту...',
        homework: 'Завантаження завдання...',
      },
      header: {
        newModuleTest: 'Новий модульний тест',
        editModuleTest: 'Редагування модульного тесту',
        newHomework: 'Нове домашнє завдання',
        editHomework: 'Редагування завдання',
        newTestSubtitle: 'Створіть тест для перевірки засвоєння модуля',
        editTestSubtitle: 'Редагування: {{title}}',
        defaultTestName: 'Тест',
        newHomeworkSubtitle: 'Створіть інтерактивне завдання',
        editHomeworkSubtitle: 'Редагування: {{title}}',
        defaultHomeworkName: 'Завдання',
        cancel: 'Скасувати',
        previewTooltip: 'Зберегти та переглянути як учень',
        preview: 'Перегляд',
        saving: 'Збереження...',
        save: 'Зберегти',
      },
      details: {
        testHeading: 'Деталі тесту',
        homeworkHeading: 'Деталі завдання',
        testTitleLabel: 'Назва тесту *',
        homeworkTitleLabel: 'Назва завдання *',
        testTitlePlaceholder: 'Введіть назву тесту',
        homeworkTitlePlaceholder: 'Введіть назву завдання',
        descriptionLabel: 'Опис (опціонально)',
        descriptionPlaceholder: 'Короткий опис тесту',
        passingScoreLabel: 'Прохідний бал (%)',
        timeLimitLabel: 'Ліміт часу, хв (опціонально)',
        timeLimitPlaceholder: 'Без ліміту',
        autoAssignLabel: 'Автоматично надсилати учню після завершення уроку',
        totalPointsPrefix: 'Загальна кількість балів:',
      },
      notes: {
        heading: 'Конспект для учнів',
        description: 'Додайте нотатки, які учні побачать у вкладці "Конспект". Учні не зможуть редагувати цей вміст.',
        placeholder: 'Введіть конспект уроку...',
        mediaHeading: 'Додаткові матеріали (аудіо/відео)',
      },
      exercisesSection: {
        testHeading: 'Завдання тесту ({{count}})',
        homeworkHeading: 'Вправи ({{count}})',
        addTestBtn: 'Додати завдання',
        addHomeworkBtn: 'Додати вправу',
        pickTypeHeading: 'Оберіть тип вправи:',
        cancel: 'Скасувати',
        empty: 'Немає вправ',
        emptyHint: 'Додайте першу вправу до завдання',
        exerciseLabel: 'Вправа {{index}}: {{label}}',
        pointsSuffix: '({{points}} бал{{suffix}})',
        editTooltip: 'Редагувати',
        deleteTooltip: 'Видалити',
        done: 'Готово',
        summaryQuestions: '{{count}} питань',
        summaryStatements: '{{count}} тверджень',
        statementDefault: 'Твердження не задано',
        questionDefault: 'Питання не задано',
        mcSummaryMulti: 'Питань: {{questions}}, Варіантів: {{options}}',
        mcSummarySingle: 'Варіанти: {{count}}',
        matchingSummary: 'Пар: {{count}}',
        sortingSummary: 'Елементів: {{count}}',
        wordsearchSummary: 'Слів: {{count}}',
        unjumbleSummary: 'Слів у реченні: {{count}}',
        shadowingVideo: 'Відео',
        shadowingAudio: 'Аудіо',
        shadowingNone: 'Медіа не завантажено',
        dictationAudioLoaded: 'Аудіо завантажено',
        dictationAudioMissing: 'Аудіо не завантажено',
      },
      oddOneOutDefault: 'Знайди зайве слово в кожному рядку',
      explanation: {
        label: 'Пояснення (опціонально)',
        placeholder: 'Пояснення, яке побачить учень при неправильній відповіді...',
      },
      imageField: {
        defaultLabel: 'Картинка (необов\'язково)',
        deleteImage: 'Видалити картинку',
        addImage: 'Додати картинку',
        pickSticker: 'Стікери',
      },
      audioField: {
        defaultLabel: 'Аудіо (необов\'язково)',
        deleteAudio: 'Видалити аудіо',
        addAudio: 'Додати аудіо',
      },
      mediaField: {
        defaultLabel: 'Медіа (необов\'язково)',
        addImage: 'Додати картинку',
        addAudio: 'Додати аудіо',
        addVideo: 'Додати відео',
        delete: 'Видалити',
      },
      multipleChoice: {
        questionCounter: 'Питання {{current}} з {{total}}',
        duplicateTooltip: 'Дублювати питання',
        deleteTooltip: 'Видалити питання',
        questionLabel: 'Питання *',
        questionPlaceholder: 'Введіть питання...',
        optionsLabel: 'Варіанти відповідей *',
        optionPlaceholder: 'Варіант {{index}}',
        addOption: 'Додати варіант',
        pointsLabel: 'Бали',
        duplicate: 'Дублювати',
        addQuestion: 'Додати питання',
      },
      fillBlank: {
        questionCounter: 'Питання {{current}} з {{total}}',
        duplicateTooltip: 'Дублювати питання',
        deleteTooltip: 'Видалити питання',
        questionLabel: 'Питання з пропуском *',
        questionHint: '(використовуйте ___ для позначення пропуску)',
        correctAnswerLabel: 'Правильна відповідь *',
        duplicate: 'Дублювати',
        addQuestion: 'Додати питання',
        pointsPerBlankPrefix: 'Бали за вправу:',
        pointsPerBlankSuffix: '(по 1 балу за кожен пропуск)',
      },
      matching: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'З\'єднайте елементи...',
        pairsLabel: 'Пари для з\'єднання *',
        leftPlaceholder: 'Ліва частина',
        rightPlaceholder: 'Права частина',
        addPair: 'Додати пару',
        pointsLabel: 'Бали',
        textTooltip: 'Текст',
        imageTooltip: 'Зображення',
        audioTooltip: 'Аудіо',
      },
      sorting: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Розставте елементи в правильному порядку...',
        itemsLabel: 'Елементи для сортування *',
        itemPlaceholder: 'Елемент {{index}}',
        addItem: 'Додати елемент',
        correctOrderLabel: 'Правильний порядок',
        pointsLabel: 'Бали',
      },
      fillInGaps: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Заповніть пропуски в тексті...',
        textLabel: 'Текст з пропусками *',
        textHint: '(використовуйте {{p1}}, {{p2}} для позначення пропусків)',
        correctAnswersLabel: 'Правильні відповіді для пропусків:',
        answerPlaceholder: 'Правильна відповідь',
        pointsPrefix: 'Бали за вправу:',
        pointsSuffix: '(по 1 балу за кожен пропуск)',
      },
      dragWordFill: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Перетягніть правильні слова у пропуски...',
        textLabel: 'Текст з пропусками *',
        textHint: '(використовуйте {{p1}}, {{p2}} для позначення пропусків)',
        correctAnswersLabel: 'Правильні відповіді для пропусків:',
        answerPlaceholder: 'Слово або словосполучення',
        distractorsLabel: 'Зайві слова (відволікачі)',
        distractorsHint: '— додаткові слова у полі, які учень має проігнорувати',
        distractorPlaceholder: 'Слово-відволікач',
        addDistractor: 'Додати слово-відволікач',
        removeDistractor: 'Видалити',
        pointsPrefix: 'Бали за вправу:',
        pointsSuffix: '(по 1 балу за кожен пропуск)',
      },
      anagram: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Розшифруйте слово...',
        anagramLabel: 'Анаграма {{index}}',
        deleteTooltip: 'Видалити анаграму',
        correctWordLabel: 'Правильне слово *',
        studentWillSee: 'Учень побачить такі літери:',
        reshuffle: 'Перемішати',
        hintLabel: 'Підказка (необов\'язково)',
        hintPlaceholder: 'Фрукт',
        addAnagram: 'Додати анаграму',
        pointsLabel: 'Бали',
        pointsHint: '1 бал за анаграму',
      },
      wordsearch: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Знайдіть приховані слова у сітці...',
        wordsLabel: 'Слова для пошуку *',
        wordsHint: 'Підказка — слово яке бачить учень (наприклад, українською). Слово в сітці — те, що треба знайти (наприклад, англійською).',
        hintPlaceholder: 'Підказка (напр. стілець)',
        gridWordPlaceholder: 'Слово в сітці (напр. CHAIR)',
        addWord: 'Додати слово',
        gridSizeLabel: 'Розмір сітки',
        directionsLabel: 'Розташування слів',
        directionHorizontal: 'Горизонтально',
        directionVertical: 'Вертикально',
        directionDiagonal: 'По діагоналі',
        pointsLabel: 'Бали',
        pointsHint: '1 бал за слово',
        generateGrid: 'Згенерувати сітку',
        addWordHint: 'Додайте хоча б одне слово (мін. 2 літери)',
        gridPreview: 'Попередній перегляд сітки:',
        wordsInGrid: 'Слова у сітці:',
        placementWarning: 'Увага: не всі слова вдалося розмістити. Спробуйте збільшити розмір сітки або скоротити слова.',
      },
      unjumble: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Складіть речення у правильному порядку...',
        correctSentenceLabel: 'Правильне речення *',
        sentenceHint: 'Введіть речення, слова якого будуть автоматично перемішані',
        studentWillSee: 'Учень побачить слова у такому порядку:',
        reshuffle: 'Перемішати знову',
        pointsLabel: 'Бали',
        sentenceLabel: 'Речення {{index}}',
        deleteTooltip: 'Видалити речення',
        addSentence: 'Додати речення',
        pointsHint: '1 бал за речення',
      },
      crossword: {
        rowsLabel: 'Рядків',
        colsLabel: 'Стовпців',
        wordsLabel: 'Слова кросворда',
        wordPlaceholder: 'СЛОВО',
        cluePlaceholder: 'Підказка/визначення',
        deleteWordTooltip: 'Видалити слово',
        addWord: 'Додати слово',
        generating: 'Генерація...',
        generateGrid: 'Згенерувати сітку',
        addWordHint: 'Додайте хоча б одне слово (мін. 2 літери)',
        gridPreview: 'Попередній перегляд кросворда:',
        wordCount: 'Слів у кросворді: {{count}}',
        pointsSummary: 'Бали: {{points}}',
        placementWarning: 'Увага: не всі слова вдалося розмістити. Спробуйте збільшити розмір сітки або скоротити слова.',
        tip: 'Після додавання слів натисніть "Згенерувати сітку", щоб автоматично розмістити їх у кросворді',
        clueImageDelete: 'Видалити картинку',
        clueImageUploading: 'Завантаження…',
        clueImageDrop: 'Відпустіть файл',
        clueImageAdd: 'Додати або перетягніть картинку-підказку',
      },
      exerciseMedia: {
        label: 'Медіа до вправи (необов\'язково)',
        audio: 'Аудіо',
        image: 'Зображення',
      },
      vocabulary: {
        heading: 'Словник ({{count}})',
        addWord: 'Додати слово',
        importList: 'Імпортувати список',
        description: 'Додайте слова для вивчення. Учні зможуть вчити їх за допомогою карток у вкладці "Словник".',
        empty: 'Немає слів у словнику',
        emptyHint: 'Додайте перше слово для вивчення',
        reorderTooltip: 'Перетягніть, щоб змінити порядок',
        wordLabel: 'Слово {{index}}',
        wordEnLabel: 'Слово (англійською) *',
        translationLabel: 'Переклад *',
        translationPlaceholder: 'Яблуко',
        transcriptionLabel: 'Транскрипція',
        imageLabel: 'Зображення',
        pronunciationLabel: 'Вимова',
        uploading: 'Завантаження…',
        dropFile: 'Відпустіть файл',
        uploadOrDrop: 'Завантажити або перетягніть',
        chooseFromStickers: 'Обрати зі стікерів',
        crop: 'Обрізати',
        cropTitle: 'Обрізати зображення',
        import: {
          title: 'Імпортувати список слів',
          description: 'По одному запису на рядок. Формат: «слово — переклад» або «слово — транскрипція — переклад». Розділювач: тире, двокрапка, табуляція або кома. Транскрипцію можна також вставляти у /…/ чи […] поряд зі словом.',
          example: 'apple — /ˈæp.əl/ — яблуко\ndog [dɒɡ] - собака\nbook: книга\nrun\tбігти',
          placeholder: 'apple — /ˈæp.əl/ — яблуко\ndog - собака\n…',
          hint: 'Вставте пари «слово — переклад» (або «слово — транскрипція — переклад»), щоб побачити попередній перегляд.',
          preview: 'Буде додано слів: {{count}}',
          cancel: 'Скасувати',
          confirm: 'Додати {{count}}',
        },
      },
      homeworkMedia: {
        addAudio: 'Додати аудіо',
        addVideo: 'Додати відео',
        uploading: 'Завантаження…',
      },
      shadowing: {
        loadingMedia: 'Завантаження медіа...',
        recognizingSpeech: 'Розпізнавання мови...',
        loadingModel: 'Завантаження моделі: {{progress}}%',
        extractedWords: 'Витягнуто {{count}} слів',
        extractionFailed: 'Не вдалося витягти тайминги. Введіть транскрипт вручну.',
        extractionError: 'Помилка витягування. Спробуйте ще раз.',
        addedWithTimings: 'Додано {{count}} слів з таймінгами',
        nameLabel: 'Назва вправи',
        namePlaceholder: 'Повторіть за диктором',
        videoLabel: 'Відео (еталон) *',
        deleteVideo: 'Видалити відео',
        uploading: 'Завантаження…',
        clickToUploadVideo: 'Натисніть, щоб завантажити відео',
        videoFormats: 'MP4, WebM, MOV до 100MB',
        orAudioLabel: 'Або аудіо (якщо без відео)',
        deleteAudio: 'Видалити аудіо',
        uploadAudio: 'Завантажити аудіо',
        transcriptLabel: 'Текст для озвучування (транскрипт) *',
        transcriptHint: 'Введіть точний текст, який учень повинен повторити. Система порівнюватиме вимову з цим текстом.',
        timingsHeading: 'Тайминги слів (караоке)',
        timingsHint: 'Витягніть тайминги для підсвічування слів під час програвання',
        extracting: 'Витягування...',
        extractTimings: 'Витягти тайминги',
        hideManual: 'Сховати ручне введення',
        showManual: 'Ввести тайминги вручну',
        manualFormatBefore: 'Формат: масив об\'єктів з полями',
        manualFormatSeconds: '(секунди)',
        pasteJsonPlaceholder: 'Вставте JSON тут...',
        apply: 'Застосувати',
        wordsWithTimings: '✓ {{count}} слів з таймінгами',
        clear: 'Очистити',
        moreCount: '+{{count}} ще',
        showSubtitles: 'Показувати субтитри',
        allowReplay: 'Дозволити повторне прослуховування',
        pointsLabel: 'Бали',
        maxAttemptsLabel: 'Макс. спроб',
        passingPercentLabel: 'Прохідний %',
        howItWorks: 'Як це працює:',
      },
      dictation: {
        nameLabel: 'Назва вправи',
        namePlaceholder: 'Прослухайте і запишіть текст',
        videoLabel: 'Відео для диктанту',
        deleteVideo: 'Видалити відео',
        dropVideo: 'Відпустіть, щоб завантажити відео',
        clickOrDropVideo: 'Натисніть або перетягніть відео сюди',
        videoFormats: 'MP4, WebM, MOV до 100MB',
        audioLabel: 'Або аудіо для диктанту *',
        deleteAudio: 'Видалити аудіо',
        uploading: 'Завантаження…',
        dropAudio: 'Відпустіть, щоб завантажити аудіо',
        clickOrDropAudio: 'Натисніть або перетягніть аудіо сюди',
        audioFormats: 'MP3, WAV, OGG, M4A до 50MB',
        transcriptLabel: 'Текст аудіо (еталон) *',
        transcriptPlaceholder: 'Введіть точний текст того, що звучить в аудіо...',
        wordsCount: 'Слів: {{count}}. Перевірка ігнорує пунктуацію і регістр.',
        instructionsLabel: 'Інструкція для учня (необов\'язково)',
        instructionsPlaceholder: 'Напр. Прослухайте текст 2-3 рази, потім запишіть його',
        pointsLabel: 'Бали',
        pointsHint: 'Бали нараховуються пропорційно відсотку правильних слів.',
        howItWorks: 'Як це працює:',
      },
      trueFalse: {
        statementCounter: 'Твердження {{current}} з {{total}}',
        duplicateTooltip: 'Дублювати твердження',
        deleteTooltip: 'Видалити твердження',
        statementLabel: 'Твердження *',
        correctAnswerLabel: 'Правильна відповідь *',
        pointsLabel: 'Бали',
        addStatement: 'Додати твердження',
      },
      oddOneOut: {
        nameLabel: 'Назва вправи',
        namePlaceholder: 'Знайди зайве слово в кожному рядку',
        howItWorks: 'Як це працює',
        howItWorksDesc: 'Натисніть колечко зліва від елемента, щоб позначити його як зайвий. Кожен правильний рядок — 1 бал.',
        rowLabel: 'Рядок {{index}}',
        onePoint: '· 1 бал',
        deleteRowTooltip: 'Видалити рядок',
        itemsPerRow: 'Кількість елементів у рядку',
        markedAsOdd: 'Зайвий',
        markAsOdd: 'Позначити як зайвий',
        textTooltip: 'Текст',
        audioTooltip: 'Аудіо',
        itemPlaceholder: 'Слово {{index}}',
        deleteAudioTooltip: 'Видалити аудіо',
        uploading: 'Завантаження…',
        uploadAudio: 'Завантажити аудіо',
        explanationLabel: 'Пояснення для цього рядка (опціонально)',
        explanationPlaceholder: 'Наприклад: «Стілець» — це не фрукт',
        addRow: 'Додати рядок',
      },
      missingLetter: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Впишіть пропущені літери...',
        correctWordLabel: 'Правильне слово *',
        letterHint: 'Натисніть на літери, які треба сховати від учня:',
        letterHiddenTooltip: 'Літера прихована',
        letterHideTooltip: 'Натисніть, щоб сховати',
        pickAtLeastOne: 'Оберіть хоча б одну літеру, щоб сховати її від учня.',
        hintLabel: 'Підказка (необов\'язково)',
        hintPlaceholder: 'Фрукт',
        pointsLabel: 'Бали',
      },
      imageWord: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Впиши слово, яке зображено на картинці',
        imageLabel: 'Картинка *',
        correctWordLabel: 'Правильне слово *',
        hintLabel: 'Підказка (необов\'язково)',
        hintPlaceholder: 'Фрукт',
        pointsLabel: 'Бали',
      },
      coloring: {
        instructionLabel: 'Інструкція',
        instructionPlaceholder: 'Розмалюй малюнок за описом',
        descriptionLabel: 'Опис для учня *',
        descriptionPlaceholder: 'У хлопчика зелена шапка і червона футболка',
        svgLabel: 'Зображення (SVG) *',
        uploadSvg: 'Завантажити SVG',
        dropFile: 'Відпустіть файл, щоб завантажити',
        dropOrClick: 'Перетягніть SVG сюди або натисніть кнопку. Кожен елемент <path>, <rect>, <circle> стає окремою областю для розмальовки',
        regionsFound: 'Знайдено областей:',
        withColor: ' · із заданим кольором:',
        deleteBtn: 'Видалити',
        pickColorHint: 'Натисніть колір нижче, щоб задати правильний колір для виділеної області. Натисніть ще раз на область, щоб зняти виділення.',
        pickAreaHint: 'Натисніть на область зображення, щоб обрати її та задати правильний колір.',
        regionLabel: 'Область:',
        noColorRequirement: 'Без вимог до кольору',
        paletteLabel: 'Палітра кольорів для учня',
        standardPalette: 'Стандартна палітра',
        done: 'Готово',
        deleteColor: 'Видалити колір',
        addColor: 'Додати колір',
        pointsPerAreaLabel: 'Бали за одну область',
        pointsPerAreaHint: 'Учень отримує ці бали за кожну правильно зафарбовану область.',
        maxTotalPrefix: ' Максимум за вправу:',
        maxTotalSuffix: ' балів.',
      },
      exerciseTypes: {
        multipleChoice: 'Множинний вибір',
        multipleChoiceDesc: 'Учень обирає правильну відповідь з варіантів',
        fillBlank: 'Заповнення пропусків',
        fillBlankDesc: 'Учень вписує слово або фразу у пропуск',
        fillInGaps: 'Заповнення тексту',
        fillInGapsDesc: 'Учень заповнює декілька пропусків у тексті',
        dragWordFill: 'Перетягни слово у речення',
        dragWordFillDesc: 'Учень перетягує правильні слова з поля зверху у пропуски в реченні',
        matching: 'З\'єднання пар',
        matchingDesc: 'Учень з\'єднує елементи з лівої колонки з правою',
        sorting: 'Сортування',
        sortingDesc: 'Учень розставляє елементи в правильному порядку',
        anagram: 'Анаграма',
        anagramDesc: 'Учень розшифровує слово зі змішаних букв',
        wordsearch: 'Пошук слів',
        wordsearchDesc: 'Учень шукає приховані слова у сітці літер',
        unjumble: 'Скласти речення',
        unjumbleDesc: 'Учень складає речення з перемішаних слів',
        crossword: 'Кросворд',
        crosswordDesc: 'Учень заповнює кросворд, вводячи слова за підказками',
        shadowing: 'Озвучування (Shadowing)',
        shadowingDesc: 'Учень повторює за відео/аудіо, система оцінює вимову',
        dictation: 'Диктант',
        dictationDesc: 'Учень слухає аудіо і пише почутий текст; система підсвічує помилки',
        trueFalse: 'Правильно / Неправильно',
        trueFalseDesc: 'Учень вибирає, чи твердження правильне, чи ні',
        missingLetter: 'Пропущена літера',
        missingLetterDesc: 'Учень вписує пропущені літери у слові',
        imageWord: 'Слово по картинці',
        imageWordDesc: 'Учень бачить картинку і вписує слово по літерах',
        coloring: 'Розмальовка',
        coloringDesc: 'Учень розмальовує області SVG-зображення обраним кольором',
        oddOneOut: 'Зайве слово',
        oddOneOutDesc: 'У кожному рядку учень обирає зайвий елемент (слово або аудіо)',
      },
    },
    // ExerciseRenderer (runtime student view)
    exercises: {
      correct: 'Правильно!',
      incorrect: 'Неправильно',
      allPairsCorrect: 'Всі пари правильні!',
      correctPairsCount: 'Правильних пар: {{correct}} з {{total}}',
      openEndedSaved: 'Ваша відповідь збережена. Вчитель перевірить її.',
      unknownType: 'Невідомий тип вправи',
      matchingInstruction: "З'єднайте елементи з лівої колонки з відповідними елементами з правої колонки",
      openEndedInstruction: 'Дайте відповідь на питання',
      openEndedPlaceholder: 'Введіть вашу відповідь...',
      answerSaved: 'Відповідь збережена',
      teacherWillReview: 'Вчитель перевірить вашу відповідь пізніше.',
      unsupportedType: 'Тип вправи "{{type}}" не підтримується',
      selectHint: 'Оберіть...',
      typeMultipleChoice: 'Тест',
      typeMatching: 'Відповідність',
      typeOpenEnded: 'Відкрите питання',
      pointsSuffix: 'балів',
      scoreOut: 'Отримано балів: {{score}} з {{max}}',
      checking: 'Перевірка...',
      submit: 'Відповісти',
      retry: 'Спробувати ще раз',
    },
    viewer: {
      loading: 'Завантаження...',
      homeworkNotFound: 'Домашнє завдання не знайдено',
      backToPanel: 'Повернутися до панелі',
      previewMode: 'Режим попереднього перегляду',
      previewNote: '— це те, що бачить учень. Дії не зберігаються.',
      close: 'Закрити',
      totalPoints: 'Всього балів',
      pointsShort: 'Балів:',
      yourResult: 'Ваш результат',
      summary: 'Конспект',
      dictionary: 'Словник',
      exercises: 'Вправи',
      checkPreview: 'Перевірити відповіді (попередній перегляд)',
      completeTest: 'Завершити тест',
      checkAndSend: 'Перевірити відповіді та надіслати вчителю',
      testPassed: 'Тест складено',
      testFailedNeed: 'Не складено (потрібно {{percent}}%)',
      yourResultOf: 'Ваш результат: {{score}} з {{max}} балів',
      earnedStarsWithBonus: 'Отримано {{earned}} з 4 зірок (у т.ч. +1 за вчасно здане завдання)',
      earnedStars: 'Отримано {{earned}} з 4 зірок',
      noStars: 'Зірок не отримано',
      closePreview: 'Закрити перегляд',
      backToPanel2: 'Повернутися до панелі',
      moduleTestExitConfirm: 'Точно вийти? Результати здадуться, тест перепройти не можна буде.',
      timeTaken: 'Час проходження',
      timeTakenShort: 'Час',
      noSummaryYet: 'Вчитель не додав конспект до цього завдання',
      materials: 'Матеріали',
      viewExplanation: 'Переглянути пояснення',
      explanation: 'Пояснення',
      exerciseN: 'Вправа {{n}}',
      correctAnswer: 'Правильна відповідь:',
      viewCorrectPairs: 'Перегляньте правильні пари вище',
      questionN: 'Питання {{n}}',
      pointsN: '({{n}} балів)',
      answerPlaceholder: 'Введіть відповідь...',
      correctAnswerInline: 'Правильна відповідь:',
      types: {
        multiple_choice: 'Множинний вибір',
        fill_blank: 'Заповнення пропусків',
        fill_in_gaps: 'Заповнення тексту',
        drag_word_fill: 'Перетягни слово у речення',
        matching: "З'єднання пар",
        sorting: 'Сортування',
        anagram: 'Анаграма',
        wordsearch: 'Пошук слів',
        unjumble: 'Скласти речення',
        shadowing: 'Озвучування',
        dictation: 'Диктант',
        true_false: 'Правильно / Неправильно',
        missing_letter: 'Пропущена літера',
        image_word: 'Слово по картинці',
        coloring: 'Розмальовка',
      },
      tapHere: 'Торкніться сюди',
      dragOrTap: 'Перетягніть або торкніться',
      chooseWhereToPlace: 'Оберіть, куди розмістити:',
      availableAnswers: 'Доступні відповіді:',
      dragToOrder: 'Перетягуйте елементи, щоб розставити їх у правильному порядку',
      anagramN: 'Анаграма {{n}}',
      hint: 'Підказка: {{text}}',
      dragLetters: 'Перетягуйте букви, щоб скласти правильне слово',
      selectHint: 'Виділіть слова, проводячи по літерах горизонтально, вертикально або діагонально',
      foundOf: 'Знайдено: {{found}} з {{total}} слів',
      dragToSentence: 'Перетягуйте слова, щоб скласти правильне речення',
      dragWordFillEmptyPool: 'Усі слова розставлено. Торкніться слова у пропуску, щоб повернути його сюди.',
      statementNof: 'Твердження {{current}} з {{total}}',
      rowN: 'Рядок {{n}}',
      play: 'Відтворити',
      hintLabel: 'Підказка:',
      vocabularyTitle: 'Словник',
      pdfError: 'Не вдалося створити PDF',
      cards: 'Картки',
      list: 'Список',
      test: 'Тест',
      shuffle: 'Перемішати',
      reset: 'Скинути',
      printCards: 'Завантажити картки для друку (PDF)',
      preparingPdf: 'Готую PDF…',
      print: 'Друк',
      printCardsPdf: 'Картки для друку (PDF)',
      wordTranslation: 'Слово + переклад',
      pairCardsMem: 'Парні картки для запам\'ятовування',
      wordPicture: 'Слово + картинка',
      pairCardsAssoc: 'Парні картки для гри на асоціації',
      noWordsWithPics: 'Немає слів із картинками',
      learnedOf: 'Вивчено: {{learned}} / {{total}}',
      noWordsToLearn: 'Немає слів для вивчення',
      tapCardToFlip: 'Натисни на картку, щоб перевернути',
      stillLearning: 'Ще вчу',
      learned: 'Вивчено',
      colWord: 'Слово',
      colTranslation: 'Переклад',
      colTranscription: 'Транскрипція',
      colPronunciation: 'Вимова',
      colStatus: 'Статус',
      testDone: 'Тест завершено!',
      testResult: 'Ваш результат: {{score}} з {{total}}',
      tryAgain: 'Спробувати ще раз',
      noWordsToTest: 'Немає слів для тестування',
      questionOf: 'Питання {{current}} з {{total}}',
      correctCount: 'Правильно: {{count}}',
      next: 'Наступне',
      finish: 'Завершити',
    },
  },
  en: {
    teacherModal: {
      title: 'Student homework',
      empty: 'No homework yet',
      emptyHint: 'No student has submitted homework yet',
      statusSubmitted: 'Awaiting review',
      statusGraded: 'Graded',
      statusInProgress: 'In progress',
      sectionNotSent: 'Not sent ({{count}})',
      sectionAwaitingReview: 'Awaiting review ({{count}})',
      sectionGraded: 'Graded ({{count}})',
      gradeTitle: 'Grade work: {{name}}',
      scoreLabel: 'Score (max: {{max}})',
      scorePlaceholder: 'Auto score',
      commentLabel: 'Comment for the student',
      commentPlaceholder: 'Write a comment about the submitted work...',
      saveGrade: 'Save grade',
      cancel: 'Cancel',
      submittedAt: 'Submitted: {{date}}',
      view: 'View',
      viewWorkTitle: 'View work',
      lessonAt: 'Lesson: {{date}}',
      sending: 'Sending…',
      send: 'Send',
    },
    recorder: {
      errorNotAllowed: 'Allow microphone access to record your voice',
      errorNotFound: 'Microphone not found. Connect a microphone and try again',
      errorGeneric: 'Recording error. Check your microphone and try again',
      paused: 'Paused',
      recording: 'Recording...',
      pressToRecord: 'Press to record',
      pauseButton: 'Pause',
      resumeButton: 'Resume',
      maxSeconds: 'Max {{count}} seconds',
      yourRecording: 'Your recording ({{time}})',
      recordAgain: 'Record again',
      submitForReview: 'Submit for review',
    },
    dictation: {
      defaultQuestion: 'Listen and type the text',
      audioSectionLabel: 'Dictation audio',
      audioHint: 'You can replay it as many times as you like.',
      audioMissing: 'Audio for this dictation has not been uploaded yet.',
      answerLabel: 'Your answer',
      answerPlaceholder: 'Type what you hear here...',
      answerHint: 'Punctuation and case are ignored. You get one attempt.',
      submit: 'Submit dictation',
    },
    results: {
      perfect: 'Flawless!',
      great: 'Great job!',
      okButErrors: 'Not bad, but there are mistakes',
      okButCanImprove: 'Not bad, but you can do better',
      needsMoreWork: 'Needs more work',
      needsPractice: 'You need to practice more',
      passingScore: 'Passing score: {{score}}%',
      correct: 'Correct',
      withErrors: 'With mistakes',
      missed: 'Missed',
      extra: 'Extra',
      wordByWord: 'Word-by-word analysis',
      wordAnalysis: 'Word analysis',
      wordAnalysisHint: '(click a word for details)',
      intonationAnalysis: 'Intonation analysis',
      legendCorrect: 'Correct',
      legendPartial: 'With typos',
      legendError: 'Error / missed',
      legendExtra: 'Extra word',
      yourAnswer: 'Your answer:',
      empty: '(empty)',
      referenceText: 'Correct text:',
      referenceTextEtalon: 'Reference text:',
      missedWord: 'Missed: {{word}}',
      extraWord: 'Extra word',
      expected: 'Expected: {{word}}',
      textLabel: 'Text',
      textDescription: 'Word accuracy',
      tempoLabel: 'Tempo',
      tempoDescription: 'Speaking speed',
      intonationLabel: 'Intonation',
      intonationDescription: 'Speech melody',
      weight: 'Weight: {{value}}',
      expectedShort: 'Expected:',
      spoken: 'Said: ',
      word: 'Word: ',
      score: 'Score: ',
      pronunciationHint: 'Pronunciation needs improvement',
      sentence: 'Sentence {{n}}',
      receivedShort: 'Received:',
      rising: 'Rising',
      falling: 'Falling',
    },
    shadowing: {
      stepWatch: '1. Watch',
      stepRecord: '2. Record',
      stepResult: '3. Result',
      attempt: 'Attempt {{current}}/{{max}}',
      analysisError: 'Analysis error. Try recording again.',
      defaultQuestion: 'Listen and repeat',
      listenCarefully: 'Listen carefully to pronunciation and intonation',
      recordYourAnswer: 'Record your answer',
      listenFirst: 'Listen first',
      canRecordEarly: 'You can record without waiting for the video to end',
      recordHeading: 'Record your answer',
      recordHint: 'Repeat the text clearly and with the right intonation',
      textToRepeat: 'Text to repeat:',
      listenAgain: 'Listen again',
      analyzing: 'Analyzing your pronunciation...',
      analysisFirstLoad: 'The first load may take longer',
      progressRecognizing: 'Recognizing speech...',
      progressLoadingModel: 'Loading model: {{progress}}%',
      progressIntonation: 'Analyzing intonation...',
      progressComparing: 'Comparing to reference...',
      notRecognized: '(not recognized)',
      improveResult: 'Improve your result ({{n}} {{label}} left)',
      tryAgain: 'Try again ({{n}} left)',
      attemptsUsed: 'You have used all attempts',
      studentRecording: 'Student recording:',
      attemptSingular: 'attempt',
      attemptPlural: 'attempts',
    },
    coloring: {
      imageMissing: 'The image for this exercise has not been uploaded.',
      palette: 'Palette',
      colorLabel: 'Color {{color}}',
      erase: 'Erase',
      reset: 'Reset',
    },
    editor: {
      title: 'Homework editor',
      moduleTestTitle: 'Module test editor',
      backToDashboard: 'Back',
      saveButton: 'Save',
      saving: 'Saving...',
      addExercise: 'Add exercise',
      titleLabel: 'Title',
      descriptionLabel: 'Description',
      programLabel: 'Program',
      lessonLabel: 'Lesson',
      moduleLabel: 'Module',
      passingScoreLabel: 'Passing score',
      timeLimitLabel: 'Time limit (min)',
      autoAssignLabel: 'Auto-assign after the lesson',
      notesLabel: 'Notes',
      mediaLabel: 'Materials',
      vocabularyLabel: 'Vocabulary',
      totalPoints: 'Total points: {{points}}',
      errorTitle: 'Error',
      common: {
        cancel: 'Cancel',
        save: 'Save',
        add: 'Add',
        delete: 'Delete',
        edit: 'Edit',
        done: 'Done',
        duplicate: 'Duplicate',
        instruction: 'Instruction',
        pointsLabel: 'Points',
        image: 'Image',
        audio: 'Audio',
        video: 'Video',
        text: 'Text',
        upload: 'Upload',
        uploading: 'Uploading…',
        moveUp: 'Move up',
        moveDown: 'Move down',
      },
      alerts: {
        enterTestTitle: 'Please enter the test title',
        enterHomeworkTitle: 'Please enter the homework title',
        addAtLeastOneTestExercise: 'Add at least one exercise to the test',
        addAtLeastOneItem: 'Add at least one exercise, notes, or vocabulary word',
        saveFailed: 'Failed to save',
        fileTooLarge5: 'File too large. Max size: 5MB',
        fileTooLarge50: 'File too large. Max size: 50MB',
        fileTooLarge100: 'File too large. Max size: 100MB',
        fileTooLargeAudio50Image5: 'File too large. Max size: {{limit}}',
        uploadFailed: 'Failed to upload file: {{message}}',
        uploadAudioFirst: 'Upload video or audio first',
        uploadAudioFormats: 'Please upload an audio file (MP3, WAV, OGG, M4A)',
        uploadVideoFormats: 'Please upload a video file (MP4, WebM, MOV)',
        uploadAudioPlain: 'Please upload an audio file',
        uploadImagePlain: 'Please upload an image',
        imageOnly: 'Only images are supported',
        crosswordGenError: 'Error generating crossword',
        crosswordGenNone: 'Could not generate a grid. Try increasing the grid size.',
        crosswordGenPartial: 'Placed {{placed}} of {{total}} words. Try a larger grid or shorter words.',
        addWordMin2: 'Add at least one word (min 2 letters)',
        invalidJsonFormat: 'Invalid format. Use an array of objects with fields word, start, end.',
        parseJsonError: 'JSON parse error. Check the format.',
        dragImageFile: 'Please drop an image file',
        dragAudioFile: 'Please drop an audio file',
        svgFormat: 'Please choose an SVG file',
        svgNoPaths: 'No colorable regions (path, rect, circle, etc.) found in the SVG',
        svgProcessFailed: 'Failed to process the SVG file',
      },
      confirms: {
        deleteExerciseTitle: 'Delete exercise?',
        deleteExerciseMessage: 'Delete this exercise?',
      },
      loading: {
        test: 'Loading test...',
        homework: 'Loading homework...',
      },
      header: {
        newModuleTest: 'New module test',
        editModuleTest: 'Editing module test',
        newHomework: 'New homework',
        editHomework: 'Editing homework',
        newTestSubtitle: 'Create a test to check module mastery',
        editTestSubtitle: 'Editing: {{title}}',
        defaultTestName: 'Test',
        newHomeworkSubtitle: 'Create an interactive assignment',
        editHomeworkSubtitle: 'Editing: {{title}}',
        defaultHomeworkName: 'Homework',
        cancel: 'Cancel',
        previewTooltip: 'Save and preview as student',
        preview: 'Preview',
        saving: 'Saving...',
        save: 'Save',
      },
      details: {
        testHeading: 'Test details',
        homeworkHeading: 'Homework details',
        testTitleLabel: 'Test title *',
        homeworkTitleLabel: 'Homework title *',
        testTitlePlaceholder: 'Enter test title',
        homeworkTitlePlaceholder: 'Enter homework title',
        descriptionLabel: 'Description (optional)',
        descriptionPlaceholder: 'Short description of the test',
        passingScoreLabel: 'Passing score (%)',
        timeLimitLabel: 'Time limit, min (optional)',
        timeLimitPlaceholder: 'No limit',
        autoAssignLabel: 'Auto-send to the student after the lesson',
        totalPointsPrefix: 'Total points:',
      },
      notes: {
        heading: 'Notes for students',
        description: 'Add notes students will see in the "Notes" tab. Students cannot edit this content.',
        placeholder: 'Enter lesson notes...',
        mediaHeading: 'Extra materials (audio/video)',
      },
      exercisesSection: {
        testHeading: 'Test items ({{count}})',
        homeworkHeading: 'Exercises ({{count}})',
        addTestBtn: 'Add task',
        addHomeworkBtn: 'Add exercise',
        pickTypeHeading: 'Pick an exercise type:',
        cancel: 'Cancel',
        empty: 'No exercises',
        emptyHint: 'Add the first exercise to the homework',
        exerciseLabel: 'Exercise {{index}}: {{label}}',
        pointsSuffix: '({{points}} pt{{suffix}})',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        done: 'Done',
        summaryQuestions: '{{count}} questions',
        summaryStatements: '{{count}} statements',
        statementDefault: 'No statement set',
        questionDefault: 'No question set',
        mcSummaryMulti: 'Questions: {{questions}}, Options: {{options}}',
        mcSummarySingle: 'Options: {{count}}',
        matchingSummary: 'Pairs: {{count}}',
        sortingSummary: 'Items: {{count}}',
        wordsearchSummary: 'Words: {{count}}',
        unjumbleSummary: 'Words in sentence: {{count}}',
        shadowingVideo: 'Video',
        shadowingAudio: 'Audio',
        shadowingNone: 'No media uploaded',
        dictationAudioLoaded: 'Audio uploaded',
        dictationAudioMissing: 'Audio not uploaded',
      },
      oddOneOutDefault: 'Find the odd word in each row',
      explanation: {
        label: 'Explanation (optional)',
        placeholder: 'Explanation the student will see on wrong answer...',
      },
      imageField: {
        defaultLabel: 'Image (optional)',
        deleteImage: 'Delete image',
        addImage: 'Add image',
        pickSticker: 'Stickers',
      },
      audioField: {
        defaultLabel: 'Audio (optional)',
        deleteAudio: 'Delete audio',
        addAudio: 'Add audio',
      },
      mediaField: {
        defaultLabel: 'Media (optional)',
        addImage: 'Add image',
        addAudio: 'Add audio',
        addVideo: 'Add video',
        delete: 'Delete',
      },
      multipleChoice: {
        questionCounter: 'Question {{current}} of {{total}}',
        duplicateTooltip: 'Duplicate question',
        deleteTooltip: 'Delete question',
        questionLabel: 'Question *',
        questionPlaceholder: 'Enter question...',
        optionsLabel: 'Answer options *',
        optionPlaceholder: 'Option {{index}}',
        addOption: 'Add option',
        pointsLabel: 'Points',
        duplicate: 'Duplicate',
        addQuestion: 'Add question',
      },
      fillBlank: {
        questionCounter: 'Question {{current}} of {{total}}',
        duplicateTooltip: 'Duplicate question',
        deleteTooltip: 'Delete question',
        questionLabel: 'Question with blank *',
        questionHint: '(use ___ to mark the blank)',
        correctAnswerLabel: 'Correct answer *',
        duplicate: 'Duplicate',
        addQuestion: 'Add question',
        pointsPerBlankPrefix: 'Points for exercise:',
        pointsPerBlankSuffix: '(1 point per blank)',
      },
      matching: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Match the items...',
        pairsLabel: 'Pairs to match *',
        leftPlaceholder: 'Left side',
        rightPlaceholder: 'Right side',
        addPair: 'Add pair',
        pointsLabel: 'Points',
        textTooltip: 'Text',
        imageTooltip: 'Image',
        audioTooltip: 'Audio',
      },
      sorting: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Arrange items in the correct order...',
        itemsLabel: 'Items to sort *',
        itemPlaceholder: 'Item {{index}}',
        addItem: 'Add item',
        correctOrderLabel: 'Correct order',
        pointsLabel: 'Points',
      },
      dragWordFill: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Drag the correct words into the blanks...',
        textLabel: 'Text with blanks *',
        textHint: '(use {{p1}}, {{p2}} to mark blanks)',
        correctAnswersLabel: 'Correct answers for the blanks:',
        answerPlaceholder: 'Word or phrase',
        distractorsLabel: 'Distractor words',
        distractorsHint: '— extra words shown in the pool that the student should ignore',
        distractorPlaceholder: 'Distractor word',
        addDistractor: 'Add distractor',
        removeDistractor: 'Remove',
        pointsPrefix: 'Points for exercise:',
        pointsSuffix: '(1 point per blank)',
      },
      fillInGaps: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Fill in the gaps in the text...',
        textLabel: 'Text with gaps *',
        textHint: '(use {{p1}}, {{p2}} to mark gaps)',
        correctAnswersLabel: 'Correct answers for the gaps:',
        answerPlaceholder: 'Correct answer',
        pointsPrefix: 'Points for exercise:',
        pointsSuffix: '(1 point per gap)',
      },
      anagram: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Unscramble the word...',
        anagramLabel: 'Anagram {{index}}',
        deleteTooltip: 'Delete anagram',
        correctWordLabel: 'Correct word *',
        studentWillSee: 'Student will see these letters:',
        reshuffle: 'Shuffle',
        hintLabel: 'Hint (optional)',
        hintPlaceholder: 'Fruit',
        addAnagram: 'Add anagram',
        pointsLabel: 'Points',
        pointsHint: '1 point per anagram',
      },
      wordsearch: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Find hidden words in the grid...',
        wordsLabel: 'Words to find *',
        wordsHint: 'Clue — the word the student sees (e.g. Ukrainian). Grid word — the one to find (e.g. English).',
        hintPlaceholder: 'Clue (e.g. chair)',
        gridWordPlaceholder: 'Grid word (e.g. CHAIR)',
        addWord: 'Add word',
        gridSizeLabel: 'Grid size',
        directionsLabel: 'Word directions',
        directionHorizontal: 'Horizontal',
        directionVertical: 'Vertical',
        directionDiagonal: 'Diagonal',
        pointsLabel: 'Points',
        pointsHint: '1 point per word',
        generateGrid: 'Generate grid',
        addWordHint: 'Add at least one word (min 2 letters)',
        gridPreview: 'Grid preview:',
        wordsInGrid: 'Words in the grid:',
        placementWarning: 'Warning: not all words could be placed. Try increasing the grid size or shorter words.',
      },
      unjumble: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Assemble the sentence in the correct order...',
        correctSentenceLabel: 'Correct sentence *',
        sentenceHint: 'Enter the sentence — its words will be shuffled automatically',
        studentWillSee: 'Student will see words in this order:',
        reshuffle: 'Shuffle again',
        pointsLabel: 'Points',
        sentenceLabel: 'Sentence {{index}}',
        deleteTooltip: 'Delete sentence',
        addSentence: 'Add sentence',
        pointsHint: '1 point per sentence',
      },
      crossword: {
        rowsLabel: 'Rows',
        colsLabel: 'Columns',
        wordsLabel: 'Crossword words',
        wordPlaceholder: 'WORD',
        cluePlaceholder: 'Clue/definition',
        deleteWordTooltip: 'Delete word',
        addWord: 'Add word',
        generating: 'Generating...',
        generateGrid: 'Generate grid',
        addWordHint: 'Add at least one word (min 2 letters)',
        gridPreview: 'Crossword preview:',
        wordCount: 'Words in the crossword: {{count}}',
        pointsSummary: 'Points: {{points}}',
        placementWarning: 'Warning: not all words could be placed. Try a larger grid or shorter words.',
        tip: 'After adding words, click "Generate grid" to place them automatically',
        clueImageDelete: 'Delete image',
        clueImageUploading: 'Uploading…',
        clueImageDrop: 'Drop file',
        clueImageAdd: 'Add or drop a clue image',
      },
      exerciseMedia: {
        label: 'Exercise media (optional)',
        audio: 'Audio',
        image: 'Image',
      },
      vocabulary: {
        heading: 'Vocabulary ({{count}})',
        addWord: 'Add word',
        importList: 'Import list',
        description: 'Add words to learn. Students can practice them via flashcards in the "Vocabulary" tab.',
        empty: 'No words in vocabulary',
        emptyHint: 'Add the first word to learn',
        reorderTooltip: 'Drag to reorder',
        wordLabel: 'Word {{index}}',
        wordEnLabel: 'Word (English) *',
        translationLabel: 'Translation *',
        translationPlaceholder: 'Apple',
        transcriptionLabel: 'Transcription',
        imageLabel: 'Image',
        pronunciationLabel: 'Pronunciation',
        uploading: 'Uploading…',
        dropFile: 'Drop file',
        uploadOrDrop: 'Upload or drop file',
        chooseFromStickers: 'Choose from stickers',
        crop: 'Crop',
        cropTitle: 'Crop image',
        import: {
          title: 'Import word list',
          description: 'One entry per line. Format: "word — translation" or "word — transcription — translation". Separator: dash, colon, tab, or comma. Transcription can also be pasted inside /…/ or […] next to the word.',
          example: 'apple — /ˈæp.əl/ — яблуко\ndog [dɒɡ] - собака\nbook: книга\nrun\tбігти',
          placeholder: 'apple — /ˈæp.əl/ — яблуко\ndog - собака\n…',
          hint: 'Paste "word — translation" (or "word — transcription — translation") pairs to see a preview.',
          preview: '{{count}} words will be added',
          cancel: 'Cancel',
          confirm: 'Add {{count}}',
        },
      },
      homeworkMedia: {
        addAudio: 'Add audio',
        addVideo: 'Add video',
        uploading: 'Uploading…',
      },
      shadowing: {
        loadingMedia: 'Loading media...',
        recognizingSpeech: 'Recognizing speech...',
        loadingModel: 'Loading model: {{progress}}%',
        extractedWords: 'Extracted {{count}} words',
        extractionFailed: 'Could not extract timings. Enter transcript manually.',
        extractionError: 'Extraction error. Try again.',
        addedWithTimings: 'Added {{count}} words with timings',
        nameLabel: 'Exercise name',
        namePlaceholder: 'Repeat after the speaker',
        videoLabel: 'Video (reference) *',
        deleteVideo: 'Delete video',
        uploading: 'Uploading…',
        clickToUploadVideo: 'Click to upload video',
        videoFormats: 'MP4, WebM, MOV up to 100MB',
        orAudioLabel: 'Or audio (if no video)',
        deleteAudio: 'Delete audio',
        uploadAudio: 'Upload audio',
        transcriptLabel: 'Text to shadow (transcript) *',
        transcriptHint: 'Enter the exact text the student should repeat. Pronunciation will be compared to this text.',
        timingsHeading: 'Word timings (karaoke)',
        timingsHint: 'Extract timings to highlight words during playback',
        extracting: 'Extracting...',
        extractTimings: 'Extract timings',
        hideManual: 'Hide manual entry',
        showManual: 'Enter timings manually',
        manualFormatBefore: 'Format: array of objects with fields',
        manualFormatSeconds: '(seconds)',
        pasteJsonPlaceholder: 'Paste JSON here...',
        apply: 'Apply',
        wordsWithTimings: '✓ {{count}} words with timings',
        clear: 'Clear',
        moreCount: '+{{count}} more',
        showSubtitles: 'Show subtitles',
        allowReplay: 'Allow replay',
        pointsLabel: 'Points',
        maxAttemptsLabel: 'Max attempts',
        passingPercentLabel: 'Passing %',
        howItWorks: 'How it works:',
      },
      dictation: {
        nameLabel: 'Exercise name',
        namePlaceholder: 'Listen and type the text',
        videoLabel: 'Dictation video',
        deleteVideo: 'Delete video',
        dropVideo: 'Drop to upload video',
        clickOrDropVideo: 'Click or drop video here',
        videoFormats: 'MP4, WebM, MOV up to 100MB',
        audioLabel: 'Or dictation audio *',
        deleteAudio: 'Delete audio',
        uploading: 'Uploading…',
        dropAudio: 'Drop to upload audio',
        clickOrDropAudio: 'Click or drop audio here',
        audioFormats: 'MP3, WAV, OGG, M4A up to 50MB',
        transcriptLabel: 'Audio text (reference) *',
        transcriptPlaceholder: 'Enter the exact text that is heard in the audio...',
        wordsCount: 'Words: {{count}}. Checking ignores punctuation and case.',
        instructionsLabel: 'Student instructions (optional)',
        instructionsPlaceholder: 'E.g. Listen 2-3 times, then type it',
        pointsLabel: 'Points',
        pointsHint: 'Points are awarded in proportion to the percentage of correct words.',
        howItWorks: 'How it works:',
      },
      trueFalse: {
        statementCounter: 'Statement {{current}} of {{total}}',
        duplicateTooltip: 'Duplicate statement',
        deleteTooltip: 'Delete statement',
        statementLabel: 'Statement *',
        correctAnswerLabel: 'Correct answer *',
        pointsLabel: 'Points',
        addStatement: 'Add statement',
      },
      oddOneOut: {
        nameLabel: 'Exercise name',
        namePlaceholder: 'Find the odd word in each row',
        howItWorks: 'How it works',
        howItWorksDesc: 'Click the circle on the left of an item to mark it as odd. Each correct row = 1 point.',
        rowLabel: 'Row {{index}}',
        onePoint: '· 1 point',
        deleteRowTooltip: 'Delete row',
        itemsPerRow: 'Items per row',
        markedAsOdd: 'Odd',
        markAsOdd: 'Mark as odd',
        textTooltip: 'Text',
        audioTooltip: 'Audio',
        itemPlaceholder: 'Word {{index}}',
        deleteAudioTooltip: 'Delete audio',
        uploading: 'Uploading…',
        uploadAudio: 'Upload audio',
        explanationLabel: 'Explanation for this row (optional)',
        explanationPlaceholder: 'E.g. "Chair" is not a fruit',
        addRow: 'Add row',
      },
      missingLetter: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Fill in the missing letters...',
        correctWordLabel: 'Correct word *',
        letterHint: 'Click letters to hide them from the student:',
        letterHiddenTooltip: 'Letter hidden',
        letterHideTooltip: 'Click to hide',
        pickAtLeastOne: 'Pick at least one letter to hide from the student.',
        hintLabel: 'Hint (optional)',
        hintPlaceholder: 'Fruit',
        pointsLabel: 'Points',
      },
      imageWord: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Type the word shown in the picture',
        imageLabel: 'Image *',
        correctWordLabel: 'Correct word *',
        hintLabel: 'Hint (optional)',
        hintPlaceholder: 'Fruit',
        pointsLabel: 'Points',
      },
      coloring: {
        instructionLabel: 'Instruction',
        instructionPlaceholder: 'Color the picture per the description',
        descriptionLabel: 'Description for student *',
        descriptionPlaceholder: 'The boy has a green hat and a red T-shirt',
        svgLabel: 'Image (SVG) *',
        uploadSvg: 'Upload SVG',
        dropFile: 'Drop file to upload',
        dropOrClick: 'Drop SVG here or click the button. Each <path>, <rect>, <circle> becomes a colorable region',
        regionsFound: 'Regions found:',
        withColor: ' · with color set:',
        deleteBtn: 'Delete',
        pickColorHint: 'Click a color below to set the correct color for the selected region. Click the region again to deselect.',
        pickAreaHint: 'Click a region in the image to select it and set the correct color.',
        regionLabel: 'Region:',
        noColorRequirement: 'No color requirement',
        paletteLabel: 'Color palette for the student',
        standardPalette: 'Standard palette',
        done: 'Done',
        deleteColor: 'Delete color',
        addColor: 'Add color',
        pointsPerAreaLabel: 'Points per region',
        pointsPerAreaHint: 'Student earns these points for each correctly colored region.',
        maxTotalPrefix: ' Max for exercise:',
        maxTotalSuffix: ' points.',
      },
      exerciseTypes: {
        multipleChoice: 'Multiple choice',
        multipleChoiceDesc: 'Student picks the correct answer from options',
        fillBlank: 'Fill in the blank',
        fillBlankDesc: 'Student types a word or phrase into a blank',
        fillInGaps: 'Fill in the gaps',
        fillInGapsDesc: 'Student fills several gaps in a text',
        dragWordFill: 'Drag word into sentence',
        dragWordFillDesc: 'Student drags correct words from the top pool into blanks in the sentence',
        matching: 'Matching pairs',
        matchingDesc: 'Student matches items from the left column with the right',
        sorting: 'Sorting',
        sortingDesc: 'Student arranges items in the correct order',
        anagram: 'Anagram',
        anagramDesc: 'Student unscrambles a word from mixed letters',
        wordsearch: 'Word search',
        wordsearchDesc: 'Student finds hidden words in a letter grid',
        unjumble: 'Unjumble sentence',
        unjumbleDesc: 'Student assembles a sentence from mixed words',
        crossword: 'Crossword',
        crosswordDesc: 'Student fills a crossword, entering words by clues',
        shadowing: 'Shadowing',
        shadowingDesc: 'Student repeats after video/audio, the system scores pronunciation',
        dictation: 'Dictation',
        dictationDesc: 'Student listens to audio and writes what they hear; the system highlights mistakes',
        trueFalse: 'True / False',
        trueFalseDesc: 'Student decides whether the statement is true or false',
        missingLetter: 'Missing letter',
        missingLetterDesc: 'Student fills missing letters in a word',
        imageWord: 'Word from picture',
        imageWordDesc: 'Student sees a picture and types the word letter by letter',
        coloring: 'Coloring',
        coloringDesc: 'Student colors regions of an SVG image with the chosen color',
        oddOneOut: 'Odd one out',
        oddOneOutDesc: 'Student picks the odd item (word or audio) in each row',
      },
    },
    exercises: {
      correct: 'Correct!',
      incorrect: 'Incorrect',
      allPairsCorrect: 'All pairs are correct!',
      correctPairsCount: 'Correct pairs: {{correct}} of {{total}}',
      openEndedSaved: 'Your answer has been saved. The teacher will review it.',
      unknownType: 'Unknown exercise type',
      matchingInstruction: 'Match items in the left column with the items in the right column',
      openEndedInstruction: 'Answer the question',
      openEndedPlaceholder: 'Type your answer...',
      answerSaved: 'Answer saved',
      teacherWillReview: 'The teacher will review your answer later.',
      unsupportedType: 'Exercise type "{{type}}" is not supported',
      selectHint: 'Select...',
      typeMultipleChoice: 'Quiz',
      typeMatching: 'Matching',
      typeOpenEnded: 'Open question',
      pointsSuffix: 'pts',
      scoreOut: 'Score: {{score}} of {{max}}',
      checking: 'Checking...',
      submit: 'Submit',
      retry: 'Try again',
    },
    viewer: {
      loading: 'Loading...',
      homeworkNotFound: 'Homework not found',
      backToPanel: 'Back to dashboard',
      previewMode: 'Preview mode',
      previewNote: '— this is what the student sees. Actions are not saved.',
      close: 'Close',
      totalPoints: 'Total points',
      pointsShort: 'Points:',
      yourResult: 'Your result',
      summary: 'Summary',
      dictionary: 'Vocabulary',
      exercises: 'Exercises',
      checkPreview: 'Check answers (preview)',
      completeTest: 'Complete test',
      checkAndSend: 'Check answers and send to teacher',
      testPassed: 'Test passed',
      testFailedNeed: 'Not passed (need {{percent}}%)',
      yourResultOf: 'Your score: {{score}} of {{max}} points',
      earnedStarsWithBonus: 'Earned {{earned}} of 4 stars (incl. +1 for submitting on time)',
      earnedStars: 'Earned {{earned}} of 4 stars',
      noStars: 'No stars earned',
      closePreview: 'Close preview',
      backToPanel2: 'Back to dashboard',
      moduleTestExitConfirm: 'Leave the test? Your current answers will be submitted, and you will not be able to retake it.',
      timeTaken: 'Time taken',
      timeTakenShort: 'Time',
      noSummaryYet: 'The teacher did not add a summary for this homework',
      materials: 'Materials',
      viewExplanation: 'View explanation',
      explanation: 'Explanation',
      exerciseN: 'Exercise {{n}}',
      correctAnswer: 'Correct answer:',
      viewCorrectPairs: 'See the correct pairs above',
      questionN: 'Question {{n}}',
      pointsN: '({{n}} pts)',
      answerPlaceholder: 'Enter your answer...',
      correctAnswerInline: 'Correct answer:',
      types: {
        multiple_choice: 'Multiple choice',
        fill_blank: 'Fill in the blank',
        fill_in_gaps: 'Fill in the text',
        drag_word_fill: 'Drag word into sentence',
        matching: 'Match pairs',
        sorting: 'Sorting',
        anagram: 'Anagram',
        wordsearch: 'Word search',
        unjumble: 'Make a sentence',
        shadowing: 'Shadowing',
        dictation: 'Dictation',
        true_false: 'True / False',
        missing_letter: 'Missing letter',
        image_word: 'Word from picture',
        coloring: 'Coloring',
      },
      tapHere: 'Tap here',
      dragOrTap: 'Drag or tap',
      chooseWhereToPlace: 'Choose where to place:',
      availableAnswers: 'Available answers:',
      dragToOrder: 'Drag items to arrange them in the correct order',
      anagramN: 'Anagram {{n}}',
      hint: 'Hint: {{text}}',
      dragLetters: 'Drag letters to make the correct word',
      selectHint: 'Select words by dragging over letters horizontally, vertically or diagonally',
      foundOf: 'Found: {{found}} of {{total}} words',
      dragToSentence: 'Drag words to build the correct sentence',
      dragWordFillEmptyPool: 'All words placed. Tap a word inside a blank to send it back here.',
      statementNof: 'Statement {{current}} of {{total}}',
      rowN: 'Row {{n}}',
      play: 'Play',
      hintLabel: 'Hint:',
      vocabularyTitle: 'Vocabulary',
      pdfError: 'Failed to create PDF',
      cards: 'Cards',
      list: 'List',
      test: 'Test',
      shuffle: 'Shuffle',
      reset: 'Reset',
      printCards: 'Download printable cards (PDF)',
      preparingPdf: 'Preparing PDF…',
      print: 'Print',
      printCardsPdf: 'Printable cards (PDF)',
      wordTranslation: 'Word + translation',
      pairCardsMem: 'Paired cards for memorization',
      wordPicture: 'Word + picture',
      pairCardsAssoc: 'Paired cards for association',
      noWordsWithPics: 'No words with pictures',
      learnedOf: 'Learned: {{learned}} / {{total}}',
      noWordsToLearn: 'No words to learn',
      tapCardToFlip: 'Tap the card to flip',
      stillLearning: 'Still learning',
      learned: 'Learned',
      colWord: 'Word',
      colTranslation: 'Translation',
      colTranscription: 'Transcription',
      colPronunciation: 'Pronunciation',
      colStatus: 'Status',
      testDone: 'Test completed!',
      testResult: 'Your score: {{score}} of {{total}}',
      tryAgain: 'Try again',
      noWordsToTest: 'No words to test',
      questionOf: 'Question {{current}} of {{total}}',
      correctCount: 'Correct: {{count}}',
      next: 'Next',
      finish: 'Finish',
    },
  },
};

export default dict;
